// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-3nj","top":"styles_top__2-HK7"};